export default function PlayerLgWebos() {
  return (
    <div className="prose">
      <h2>LG (WebOS)</h2>
      <p>Deployment and configuration for LG webOS signage displays.</p>
      <ul>
        <li>Supported webOS versions and models — Todo</li>
        <li>App installation and permissions — Todo</li>
        <li>Device settings, remote management, updates — Todo</li>
      </ul>
    </div>
  )
}
